import styled from 'styled-components';

export const AddressContainer = styled.div`
  @media (max-width: 768px) {
    width: calc(100% - 143.2px);
    min-width: 265px;
  }
  position: absolute;
  background: white;
  color: var(--navy-green-100, #38433f);
  font-variant-numeric: lining-nums tabular-nums;
  font-family: Gilroy;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  text-align: start;
  padding: 1rem;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const SingleAddress = styled.div`
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;

  :hover {
    cursor: pointer;
    background: rgba(234, 234, 234, 0.51);
  }
`;
